export const routes = {
  home: '/',
  login: '/login',
  agenda: '/agenda',
  config: '/config',
  new: '/new',
  recibo: '/recibo',
  informpassword: '/informpassword'
};
